const GA_ID = process.env.REACT_APP_GA_ID;

export const trackEvent = (eventName, params = {}) => {
  if (!window.gtag || !GA_ID) return;
  window.gtag('event', eventName, params);
};
